import { SiteContextValue } from "./types";

export const isKnownSiteId = (siteId: string, siteIds: string[]): boolean => {
  const MultiSiteIds = new Set(siteIds);
  return MultiSiteIds.has(siteId);
};

export const initialMultiSiteContext: SiteContextValue = {
  baseUrl: "",
  siteId: "",
  blogId: null,
  valid: false,
  checked: false,
  // When on the root domain (no valid subdomain), target the root API directly
  // so lookup calls don't produce double-slash URLs.
  getApiUrl: (pathSuffix: string): string => {
    return `${WP_API_PREFIX}/${pathSuffix}`;
  },
};

export const WP_API_PREFIX = process.env.REACT_APP_WP_API_PREFIX ?? "https://www.apismapp.com";
export const getSiteBaseUrl = (siteId: string): string => {
  return `${WP_API_PREFIX}/${siteId}`;
};

export const getSiteGraphqlUrl = (): string => {
  const subdomain = window.location.hostname.split(".")[0];
  return `${WP_API_PREFIX}/${subdomain}/smapi`;
};
